import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_PAYROLL_DEDUCTIONS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.CREATE_PAYROLL_DEDUCTION:
      return { ...state, ..._.mapKeys(action.payload, "Id") };
    case type.EDIT_PAYROLL_DEDUCTION:
      return { ...state, ..._.mapKeys(action.payload, "Id") };
    case type.DELETE_PAYROLL_DEDUCTION:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
